export const SET_FORM = 'SET_FORM';
export const FETCH_BANKS = 'FETCH_BANKS';
export const SET_STATE = "SET_STATE";
export const CHANGE_FORM = "CHANGE_FORM";
export const PAYMENT_CONFIRM = "PAYMENT_CONFIRM"
export const PAYMENT_NOT_SUPPORTED = "PAYMENT_NOT_SUPPORTED";

// Constants
export const BARCODE_NOT_FOUND = "Código de barras não localizado em nossa base de dados";
export const NOT_SUPPORTED_BILL = "Tipo de boleto não suportado";


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/types.js